import { EDynamicFormField, IField } from '@app/modules'

import { wireStates } from '../country-states'

export const ADD_NEW_OGB_FORM: IField[] = [
  {
    label: 'Nickname',
    name: 'accountName',
    placeholder: 'Enter your account nickname',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
]

export const ADD_NEW_ZELLE_FORM: IField[] = [
  {
    label: 'Zelle Account Email',
    name: 'accountName',
    placeholder: 'Enter your Zelle email',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
]

export const ADD_NEW_EU_FORM: IField[] = [
  {
    label: 'IBAN',
    name: 'iban',
    placeholder: 'Enter your IBAN',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
]

export const ADD_NEW_AU_FORM: IField[] = [
  {
    label: 'BSB Code',
    name: 'bsbCode',
    placeholder: 'Enter your BSB Code',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Account Number',
    name: 'accountNumber',
    placeholder: 'Enter your Account Number',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
]

export const ADD_NEW_UK_FORM: IField[] = [
  {
    label: 'UK Sort Code',
    name: 'ukSortCode',
    placeholder: 'Enter your UK Sort Code',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Account Number',
    name: 'accountNumber',
    placeholder: 'Enter your Account Number',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
]

export const ADD_NEW_CA_FORM: IField[] = [
  {
    label: 'Instiution Number',
    name: 'institutionNumber',
    placeholder: 'Enter your Institution Number',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Transit Number',
    name: 'transitNumber',
    placeholder: 'Enter your Transit Number',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Account Number',
    name: 'accountNumber',
    placeholder: 'Enter your Account Number',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Account Type',
    name: 'accountType',
    placeholder: 'Enter your Account Type',
    rules: [{ required: true }],
    type: EDynamicFormField.SELECT,
    options: [
      { value: 'checking', label: 'Checking' },
      { value: 'savings', label: 'Savings' },
    ],
  },
]

export const ADD_NEW_C2C_FORM: IField[] = [
  {
    label: 'Account Number',
    name: 'accountNumber',
    placeholder: 'Enter your OGB account number',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
]

export const ADD_NEW_ACH_FORM: IField[] = [
  {
    label: 'Name',
    name: 'accountName',
    placeholder: 'Enter your name',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Routing Number',
    name: 'routingNumber',
    placeholder: 'Enter Routing Number',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Account Number',
    name: 'accountNumber',
    placeholder: 'Enter Account Number',
    rules: [{ required: false }],
    type: EDynamicFormField.INPUT,
  },

  {
    label: 'Account Type',
    name: 'accountType',
    placeholder: 'Select Account Type',
    rules: [{ required: true }],
    type: EDynamicFormField.SELECT,
    options: [
      { value: 'checking', label: 'Checking' },
      { value: 'savings', label: 'Savings' },
    ],
  },
  {
    label: 'Bank Name',
    name: 'recBankName',
    placeholder: 'Enter name of the Bank Account',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Receiver Bank Address',
    name: 'recBankAddress',
    placeholder: 'Enter street address',
    rules: [{ required: true }],
    type: EDynamicFormField.INPUT,
  },
  {
    label: 'Receiver Bank Address 2',
    name: 'recBankAddress2',
    placeholder: 'Enter street address 2',
    rules: [{ required: false }],
    type: EDynamicFormField.INPUT,
  },
  {
    inline: [
      {
        label: 'City',
        name: 'cityb',
        placeholder: 'Enter city',
        rules: [{ required: true }],
        type: EDynamicFormField.INPUT,
      },
      {
        label: 'Country',
        name: 'countryb',
        placeholder: 'Enter Country',
        rules: [
          {
            message: 'Country is required',
            required: true,
          },
        ],
        type: EDynamicFormField.SELECT,
        options: [{ label: 'US', value: 'US' }],
      },
    ],
  },
  {
    inline: [
      {
        label: 'State',
        name: 'regionb',
        placeholder: 'Enter Your State',
        rules: [
          {
            message: 'State is required',
            required: true,
          },
        ],
        type: EDynamicFormField.SELECT,
        options: wireStates.US,
      },
      {
        label: 'Postal code',
        name: 'postalCodeb',
        placeholder: 'Enter postal code',
        rules: [{ required: true }],
        type: EDynamicFormField.INPUT,
      },
    ],
  },
]
